import type { JSX } from 'react';

import { Glyph, type IconProps } from './Glyph';

/** Chrome: theme, language, trust and dismissal. */

export function SunIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.2 5.2l1.4 1.4M17.4 17.4l1.4 1.4M18.8 5.2l-1.4 1.4M6.6 17.4l-1.4 1.4" />
      </g>
    </Glyph>
  );
}

export function MoonIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5" />
    </Glyph>
  );
}

export function LanguageIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M3.5 12h17" />
        <path d="M12 3.5c2.5 2.5 3.6 5.4 3.6 8.5s-1.1 6-3.6 8.5c-2.5-2.5-3.6-5.4-3.6-8.5S9.5 6 12 3.5Z" />
      </g>
    </Glyph>
  );
}

export function ShieldIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <path d="M12 3.5 19 6v6c0 4-3 7-7 8.5C8 19 5 16 5 12V6z" />
        <path d="m9 12 2 2 4-4" />
      </g>
    </Glyph>
  );
}

export function CloseIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <path d="m6 6 12 12M18 6 6 18" />
    </Glyph>
  );
}

export function CalendarIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <rect height="16" rx="3" width="17" x="3.5" y="4.5" />
        <path d="M3.5 9.5h17M8 3v3M16 3v3" />
      </g>
    </Glyph>
  );
}

export function SlidersIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <path d="M4 7h10M18 7h2M4 17h4M12 17h8" />
        <circle cx="16" cy="7" r="2" />
        <circle cx="10" cy="17" r="2" />
      </g>
    </Glyph>
  );
}

export function LogoutIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <path d="M14.5 4.5h-7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h7" />
        <path d="M16 8.5 19.5 12 16 15.5M19.5 12H10" />
      </g>
    </Glyph>
  );
}

export function SpinnerIcon({ className = 'size-4' }: IconProps): JSX.Element {
  return (
    <svg aria-hidden="true" className={`animate-spin ${className}`} fill="none" viewBox="0 0 24 24">
      <circle cx="12" cy="12" opacity="0.25" r="9" stroke="currentColor" strokeWidth="2.5" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
    </svg>
  );
}

/**
 * An attachment — the paperclip, because it is the one file metaphor that
 * needs no explaining to a patient who has used any messaging app.
 */

/** «ارسال» — a paper plane pointing along the reading direction. */

export function SearchIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <circle cx="11" cy="11" r="6.5" />
        <path d="m16 16 4 4" />
      </g>
    </Glyph>
  );
}

/**
 * The clear cross inside a text field — lighter than CloseIcon, which is the
 * dismissal glyph on dialogs and banners and would read as "close this" here.
 */
export function ClearIcon(props: IconProps): JSX.Element {
  return (
    <Glyph {...props}>
      <g>
        <circle cx="12" cy="12" r="8.5" />
        <path d="m9.5 9.5 5 5M14.5 9.5l-5 5" />
      </g>
    </Glyph>
  );
}
